// extracted by mini-css-extract-plugin
export var dark = "stacks-provider-search-module--dark--373f0";
export var darkForest = "stacks-provider-search-module--darkForest--e5972";
export var dropdownContainer = "stacks-provider-search-module--dropdownContainer--1dd54";
export var dropdownItem = "stacks-provider-search-module--dropdownItem--2a9e1";
export var locationContainer = "stacks-provider-search-module--locationContainer--f0706";
export var locationErrorContainer = "stacks-provider-search-module--locationErrorContainer--834c9";
export var matcha = "stacks-provider-search-module--matcha--2712a";
export var sage = "stacks-provider-search-module--sage--ca3d3";
export var stacksProviderSearch = "stacks-provider-search-module--stacksProviderSearch--4a6ab";
export var white = "stacks-provider-search-module--white--8574d";
export var withBorder = "stacks-provider-search-module--withBorder--b17c7";